
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.13 4.712L20.889.469A1.591 1.591 0 0019.758 0c-.41 0-.82.156-1.132.469L.469 18.626a1.6 1.6 0 000 2.263L4.71 25.13c.313.313.722.469 1.131.469.41 0 .82-.156 1.132-.469L25.13 6.974a1.599 1.599 0 000-2.262zm-7.158 5.461l-2.545-2.545 4.33-4.33 2.545 2.545-4.33 4.33z","fill":"#8768E2"}}),_c('path',{attrs:{"d":"M12 3.2l-.8 1.6-.8-1.6-1.6-.8 1.6-.8.8-1.6.8 1.6 1.6.8-1.6.8zM5.333 5.334L4 8 2.667 5.334 0 4l2.667-1.333L4 0l1.333 2.667L8 4 5.333 5.334zM20.267 17.067L21.6 14.4l1.333 2.667L25.6 18.4l-2.667 1.334L21.6 22.4l-1.333-2.666L17.6 18.4l2.667-1.333z","fill":"#C0ABFF"}})])
          )
        }
      }
    